const list = {
  path: 'advertising',
  component: resolve => require(['@/pages/admin/platform/advertising'], resolve)
}

export default list
